const key = "KEY_IS_NinjaSalary";
export default key;
